import { IPolicemenValues } from "interfaces/Policeman";
import { IReport } from "interfaces/Report";

export type PaymentValues = {
  additional: number;
  baseValue: number;
  total: number;
}

export type ClientValue = {
  kmValue: PaymentValues;
  hourValue: PaymentValues;
  productRegionId?: string;
  minimumBilling: number;
  regionValue: number;
  rec: number;
};

export type PolicemanValue =  {
  kmValue: PaymentValues;
  hourValue: PaymentValues;
  exitValue: number;
  tollValue?: number;
  pr?: number;
}

export type ValueTypes = {
  policeman: PolicemanValue;
  client: ClientValue;
}

export type HandlePolicemanValueChangeParams = {
  key: keyof PaymentValues;
  value: number;
  type: 'hour' | 'km';
}

export function sumPolicemanValues(values: PolicemanValue) {
  const hourValue = values.hourValue;
  const kmValue = values.kmValue;

  return hourValue.total + kmValue.total + values.exitValue + (values.tollValue ?? 0);
}

export function sumClientValues(values: ClientValue) {
  const hourValue = values.hourValue;
  const kmValue = values.kmValue;

  return hourValue.total + kmValue.total + values.minimumBilling + values.regionValue;
}

type TransformPaymentValues = {
  report: IReport;
  policemanValues: IPolicemenValues | undefined;
}

export const initialPaymentValues = {
  policeman: {
    hourValue: {
      additional: 0,
      baseValue: 0,
      total: 0
    },
    kmValue: {
      additional: 0,
      baseValue: 0,
      total: 0
    },
    tollValue: 0,
    exitValue:  0,
    pr: 0
  },
  client: {
    hourValue: {
      additional: 0,
      baseValue: 0,
      total: 0
    },
    kmValue: {
      additional: 0,
      baseValue: 0,
      total: 0
    },
    rec: 0,
    regionValue: 0,
    minimumBilling: 0,
  }
}

export function transformPaymentValues({
  report,
  policemanValues
}: TransformPaymentValues): ValueTypes {
  const values = {  ...initialPaymentValues };

  values.client = !(report.recPaymentInfo && Object.keys(report.recPaymentInfo).length > 0)
    ? initialPaymentValues.client 
    : {
      ...report.recPaymentInfo,
      rec: report.rec ?? 0
    };

  values.policeman = !(report.prPaymentInfo && Object.keys(report.prPaymentInfo).length > 0) ? {
    ...initialPaymentValues.policeman,
    hourValue: {
      ...initialPaymentValues.policeman.hourValue,
      baseValue: policemanValues?.additionalHour ?? 0
      },
      kmValue: {
        ...initialPaymentValues.policeman.kmValue,
        baseValue: policemanValues?.additionalKm ?? 0
      },
      exitValue: policemanValues?.exitValue ?? 0,
      pr: policemanValues?.exitValue ?? 0
    } : {
      ...report.prPaymentInfo,
      pr: report.pr ?? 0
    };

  return values;
}
